import { useContext, useState } from "react";
import Context from "./Context";
import styled from "styled-components";
import { encontrarVideo } from "./utils";
import { FiYoutube } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa6";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";

export default function Todas() {
  const { setId,setNotas,notas,setTempo,setMostrandoTodas,videos } = useContext(Context);
  const [op,setOp]=useState(false)
  const [editando,setEditando]=useState(false)
  const [texto,setTexto]=useState('')
  const [descricao,setDescricao]=useState('')
  function excluir(i){
    const nova=[]
    const max=notas.length-1
    const indice=max-i
    for(let k=0;k<=max;k++){
      if(k!=indice)nova.push(notas[k])
    }
    setNotas(nova)
  }
  function salvarEdicao(){
    const nova=[]
    const max=notas.length-1
    const indice=max-editando
    for(let k=0;k<=max;k++){
      if(k!=indice){
        nova.push(notas[k])
      }else{
        const atualizada={...notas[k],texto}
        nova.push(atualizada)
      }
    }
    setTexto('')
    setEditando(false)
    setNotas(nova)
  }
  function mandarWhatsapp(n){
    let msg=`videonotes.com.br/point/${n.id}/${Math.round(n.num)}/${n.texto.replaceAll(' ','-')}`
    window.open(`https://wa.me/?text=${msg}`, "_blank")
  }
  return(
    <Tudo>
        {notas.length==0?<h6>Você ainda não possui notas</h6>:
        [...notas].reverse().map((n,i)=>{
          const {titulo}=encontrarVideo(n.id,videos)
          return<Nota
          onMouseEnter={() => setOp(i)}
            onMouseLeave={() => setOp(false)}
        >
          {editando===i?<></>:<Clicavel onClick={()=>{
            console.log(n)
            setId(n.id);setTempo(n.num);setMostrandoTodas(false)}}/>}
          {editando===i?
          <button onClick={salvarEdicao}>Salvar</button>:<></>}
          {i===op&&editando===false?
          <Aba>
            <section>
            <Y onClick={()=>{setEditando(i);setTexto(n.texto)}}
              onMouseEnter={() => setDescricao('Editar Nota')}
            onMouseLeave={() => setDescricao('')}>
              <FaRegEdit />
            </Y>
            <Y onClick={()=>excluir(i)}
              onMouseEnter={() => setDescricao('Apagar Nota')}
            onMouseLeave={() => setDescricao('')}>
              <FaRegTrashAlt />
            </Y>
            <Y onClick={()=>{window.open(`https://www.youtube.com/watch?v=${n.id}&t=${Math.round(n.num)}`, "_blank");}}
              onMouseEnter={() => setDescricao('Ver no Youtube')}
            onMouseLeave={() => setDescricao('')}>
              <FiYoutube style={{color:'red'}} />
            </Y>
            <Y onClick={()=>mandarWhatsapp(n)}
              onMouseEnter={() => setDescricao('Compartilhar')}
            onMouseLeave={() => setDescricao('')}>
              <FaWhatsapp style={{color:'green'}} />
            </Y>
            </section>
            <p style={{color:'black'}}>{descricao}</p>
          </Aba>:<></>}
          <section>
           {editando===i?<textarea
              value={texto}
              onChange={(e)=>setTexto(e.target.value)}
           />:<h1>{n.texto} </h1>}
           <p><small>[{n.minutos}] {titulo}</small></p>
           </section>
        </Nota>})}
    </Tudo>
  )
}
const Clicavel=styled.div`
width:100%;height:100%;
border-radius:10px;
cursor:pointer;
position:absolute;
`
const Y=styled.div`
width:30px;height:20px;
border-radius:10px;
cursor:pointer;
margin:5px;
font-size:25px;
`
const Aba=styled.div`
flex-direction:column;
width: 170px;
height:73px;
background:white;
justify-content:space-between;
padding:10px;color:black;
position:absolute;
border-radius:10px;
right:-170px;
top:0;
p{color:black;width:100%;text-align:center;margin-top:-10px;}
section{display:flex;justify-content:space-evenly;}
@media(max-width:850px){
top:70px;right:0;z-index:7;
}
`
const Nota=styled.div`
width: max-content;
position:relative;
cursor:pointer;
color:white;
background:seagreen;
justify-content:space-between;
padding:10px;
margin-bottom:10px;
border-radius:10px;
max-width:98%;
h1{margin:0;font-size:18px;font-weight:400;white-space: pre-line;}
p{margin:5px 0 0 0;color:#bfbfbf}

  button{
background:#38dd35;
cursor:pointer;
width:100px;
height:50px;
position:absolute;
border-radius:10px;
right:-100px;
top:0;border:0;
}
textarea{
padding:5px;box-sizing:border-box;
border-radius:10px;border:0;
width:250px;
height:80px;
resize: none;    
}
`
const Tudo=styled.div`
position:sticky;top:0;
width:calc(100% - 200px);
height:100%;
flex-direction:column;
padding:20px 20px 0 20px;

overflow:auto;
@media(max-width:850px){
width:100%
}
h6{color:white;font-size:20px;
width:100%;height:100%;display:flex;
align-items:center;justify-content:center;}
`
